import React from 'react'
import styled from 'styled-components'

import NavLink from '../NavLink'
import {
  COLORS,
  typeScale,
  media,
  hover,
  CSS_ELEMENTS_RESETS,
  THEME,
} from '../../styles'
import Icon from '../Icon'

const Styled = styled.footer`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  padding: 0 0.8rem 1.2rem;
  ${media.medium`
    justify-content: space-between;
  `}
`
Styled.recipeLink = styled(({ isLoading, to, children, ...rest }) =>
  to ? (
    <NavLink to={to} {...rest}>
      {children}
    </NavLink>
  ) : (
    <div {...rest}>{children}</div>
  ),
)`
  display: none;
  ${({ isLoading }) => media.medium`
    display: block;
    margin: 0;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    ${typeScale('caption', { lineHeight: '3rem' })};
    box-sizing: border-box;
    border: 0.1rem solid ${THEME.COLORS.foreground.secondary};
    height: 3.2rem;
    text-decoration: none;
    border-radius: 9999px;
    transition: border-color 0.2s ease-in-out, color 0.2s ease-in-out,
      background-color 0.2s ease-in-out;
    background-color: ${THEME.COLORS.background.secondary};
    color: ${THEME.COLORS.foreground.primary};
    ${hover`
      border-color: ${COLORS.primary};
      background-color: ${COLORS.primary};
      color: ${COLORS.white};
    `}
  
    ${
      isLoading
        ? `
        border-color: ${THEME.COLORS.background.tertiary};
        background-color: ${THEME.COLORS.background.tertiary};
        color: ${THEME.COLORS.background.tertiary};
        pointer-events: none;
      `
        : ''
    };
  `}
`
Styled.favorButton = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  width: 3.2rem;
  height: 3.2rem;
  padding: 0.4rem;
  border-radius: 9999px;
`
Styled.favorIcon = styled(Icon)`
  width: 2.4rem;
  height: 2.4rem;

  & * {
    transition: fill 0.2s ease-in-out;
  }
  ${hover`
    & * {
      fill: ${COLORS.primary};
    }
  `}
`
Styled.iconLoading = styled.svg`
  width: 3.4rem;
  height: 3.4rem;
`

export default Styled
